// extracted by mini-css-extract-plugin
export default {"input":"P7z2g","field":"jS_X3","copyBtn":"EbPix","container":"xqVi1","multipleOTPsField":"z64_R"};